module.exports = __webpack_public_path__ + "img/pack-whatsapp.c5f39eb1.png";